import React, { useState } from "react";
import Topbar from "../Topbar/Topbar";
import ProfileNavBar from "../ProfileNavbar";
import { Outlet } from "react-router-dom";
import { knf_logo, logo } from "../../assets/imgs";

const Layout = () => {
  const givenuser = JSON.parse(localStorage.getItem("loginData"));
  const [roleText, setRoleText] = useState("");
  return (
    <div className="">
      <Topbar roleText={roleText} setRoleText={setRoleText} />
      <div className="dashboard">
        <ProfileNavBar setRoleText={setRoleText} />
        <Outlet />
      </div>
      {givenuser?.type !== "admin" && (
        <footer className="text-center py-2 small d-flex justify-content-center align-items-center gap-2">
          © {new Date().getFullYear()} Powered by
          <img
            src={roleText == "knf" ? logo : knf_logo}
            alt="Sim Lian"
            height="20"
          />
          <span className="fw-semibold text-warning">KNF</span>
        </footer>
      )}
    </div>
  );
};

export default Layout;
